module.exports = __webpack_public_path__ + "static/media/kai.f8baff3b.svg";